import React from "react";
import {
  Row,
  Table,
  ButtonGroup,
  Button,
  // ButtonDropdown,
  // DropdownToggle,
  // DropdownItem,
  // DropdownMenu,
} from "reactstrap";
import { userAuditLogs } from "../../../usersConfig";
import Pagination from "../../../../../../shared/components/pagination/Pagination";
import * as env from "../../../../../../env";
import TimeSince from "../../../../../../shared/TimeSince";
import * as auditlog from "../../../../../../shared/service/auditlog";

class ProfileAuditLog extends React.Component {
  state = {
    dropdownOpen: false,
    auditLogData: [],
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    duration: "",
    key: "",
    uid: "",
    progress: "",
    records: 0,
    userPagination: {
      pageSize: env.RECORDS_PER_PAGE,
      currentPage: 1,
    },
    types: [],
  };

  toggle = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  getAuditLogs = (duration) => {
    this.setState(
      {
        duration,
        userPagination: {
          pageSize: env.RECORDS_PER_PAGE,
          currentPage: 1,
        },
      },
      () => {
        this.get();
      }
    );
  };

  filter = (filters) => {
    let filtersTypes = filters.filter((obj) => obj.checked === true);

    let types = [];

    filtersTypes.forEach((filter) => {
      types.push(filter.key);
    });

    this.setState({ types }, () => {
      this.get();
    });
  };

  get = () => {
    this.setState({
      isOpen: false,
      auditLogData: [],
    });

    this.setState({
      progress: "Loading ...",
    });

    auditlog
      .get({
        duration: this.state.duration,
        uid: this.state.uid,
        key: this.state.key,
        pagination: this.state.userPagination,
        status: this.state.types,
      })
      .then((response) => {
        this.setState({
          isOpen: false,
          auditLogData: response.events,
          records: response.total,
          progress: response.events.length === 0 ? "No record found" : "",
        });
      });
  };

  onChangePage = (pagination) => {
    if (pagination.currentPage !== this.state.userPagination.currentPage) {
      this.setState(
        { userPagination: pagination, filtersUpdated: false },
        () => {
          this.get();
        }
      );
    }
  };

  componentDidMount() {
    if (this.props.id !== undefined) {
      let uid = this.props.id;
      this.setState({ uid }, () => {
        this.get();
      });
    } else {
      this.get();
    }
  }

  printRecords = () => {
    let items = this.state.auditLogData.slice(
      this.state.startIndex,
      this.state.endIndex + 1
    );

    return (
      <React.Fragment>
        {items.map((obj) => (
          <tr key={obj.action + obj.timestamp + Math.random()}>
            <td>{obj.action}</td>
            <td>{obj.channel}</td>
            <td>{TimeSince(obj.timestamp)}</td>
          </tr>
        ))}
      </React.Fragment>
    );
  };

  pagination = () => {
    return this.state.records > env.RECORDS_PER_PAGE ? (
      <div className="audit-trail-footer">
        <Pagination
          items={this.state.auditLogData}
          records={this.state.records}
          initialPage={this.state.userPagination.currentPage}
          onChangePage={(pagination) => this.onChangePage(pagination)}
          pageSize={env.RECORDS_PER_PAGE}
        />
      </div>
    ) : (
      ""
    );
  };

  formChangeHandler = (event) => {
    let key = event.target.value;

    this.setState(
      {
        key,
        userPagination: {
          pageSize: env.RECORDS_PER_PAGE,
          currentPage: 1,
        },
      },
      () => {
        this.get();
      }
    );
  };

  render() {
    return (
      <React.Fragment>
        <Row>
          <div className="form profile-audit-log">
            <div className="form__form-group search-bar">
              <div className="form__form-group-field">
                <input
                  type="search"
                  placeholder="Search by name, type, bandwidth consumption or literally anything!"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
          </div>
          <div className="audit-trail-buttons">
            <ButtonGroup className="btn-group--justified filter-group">
              <Button
                size="sm"
                outline
                color="secondary"
                onClick={() => this.getAuditLogs("Today")}
              >
                Today
              </Button>
              <Button
                size="sm"
                outline
                color="secondary"
                onClick={() => this.getAuditLogs("7Days")}
              >
                Last 7 days
              </Button>
              <Button
                size="sm"
                outline
                color="secondary"
                onClick={() => this.getAuditLogs("30Days")}
              >
                30 days
              </Button>
              <Button
                size="sm"
                outline
                color="secondary"
                onClick={() => this.getAuditLogs("1Year")}
              >
                1 year
              </Button>
            </ButtonGroup>
            {/* <ButtonDropdown
              isOpen={this.state.dropdownOpen}
              toggle={this.toggle}
            >
              <DropdownToggle
                outline
                caret
                color="secondary"
                className="btn btn-sm btn-secondary"
              >
                Download
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>CSV</DropdownItem>
                <DropdownItem>PDF</DropdownItem>
                <DropdownItem>Microsoft Excel (.xlsx)</DropdownItem>
              </DropdownMenu>
            </ButtonDropdown> */}
          </div>
          <Table
            className="table--head-accent table--bordered"
            responsive
            hover
          >
            <thead>
              <tr>
                {userAuditLogs.map((header) => (
                  <th width={header.width} key={header.key}>
                    {header.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{this.printRecords()}</tbody>
          </Table>
          {this.pagination()}
          {this.state.progress}
        </Row>
      </React.Fragment>
    );
  }
}

export default ProfileAuditLog;
